import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivityFeed = ({ data: liveData }) => {
  const getIconForType = (type) => {
    switch (type?.toLowerCase()) {
      case 'employee': return { icon: 'Users', color: 'text-blue-500' };
      case 'payroll': return { icon: 'Banknote', color: 'text-green-500' };
      case 'invoice': return { icon: 'Receipt', color: 'text-amber-500' };
      case 'compliance': return { icon: 'Shield', color: 'text-red-500' };
      case 'application': return { icon: 'UserPlus', color: 'text-purple-500' };
      default: return { icon: 'Activity', color: 'text-slate-500' };
    }
  };

  const formatTimestamp = (ts) => {
    if (!ts) return '';
    try {
      const date = new Date(ts);
      const now = new Date();
      const diffMs = now - date;
      const diffMins = Math.floor(diffMs / 60000);
      const diffHours = Math.floor(diffMins / 60);
      const diffDays = Math.floor(diffHours / 24);

      if (diffMins < 60) return `${diffMins} mins ago`;
      if (diffHours < 24) return `${diffHours} hours ago`;
      return `${diffDays} days ago`;
    } catch (e) {
      return ts;
    }
  };

  const mockActivities = [
    { id: 1, type: 'employee', action: 'New Employee', description: 'Priya Sharma joined as Senior Facility Manager', timestamp: '2 hours ago', icon: 'UserPlus', color: 'text-success' },
    { id: 2, type: 'payroll', action: 'Payroll Processed', description: 'July 2025 salary processed for 168 employees', timestamp: '4 hours ago', icon: 'Banknote', color: 'text-primary' }
  ];

  const activities = (liveData && liveData.length > 0) 
    ? liveData.map(act => {
        const iconConfig = getIconForType(act.type);
        return {
          id: act.id,
          title: act.action || 'System Action',
          description: act.description,
          timestamp: formatTimestamp(act.timestamp),
          icon: iconConfig.icon,
          color: iconConfig.color
        };
      })
    : mockActivities;

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-lg font-semibold text-foreground">Recent Activity</h3>
          <p className="text-sm text-muted-foreground">Latest system activities and updates</p>
        </div>
        <button className="text-sm text-primary hover:text-primary/80 font-medium">
          View All
        </button>
      </div>
      
      <div className="space-y-4">
        {activities.map((activity) => (
          <div key={activity.id} className="flex items-start gap-4 p-3 hover:bg-muted rounded-lg transition-colors duration-200">
            <div className={`${activity.color} bg-muted rounded-full p-2 flex-shrink-0`}>
              <Icon name={activity.icon} size={16} />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <h4 className="text-sm font-medium text-foreground truncate">
                  {activity.title}
                </h4>
                <span className="text-xs text-muted-foreground whitespace-nowrap">
                  {activity.timestamp}
                </span>
              </div>
              <p className="text-sm text-muted-foreground mt-1 line-clamp-2">
                {activity.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      
      <div className="mt-6 pt-4 border-t border-border">
        <div className="flex items-center justify-center">
          <button className="text-sm text-primary hover:text-primary/80 font-medium flex items-center gap-2">
            <Icon name="RefreshCw" size={16} />
            Refresh Activity Feed
          </button>
        </div>
      </div>
    </div>
  );
};

export default RecentActivityFeed;